/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.ts to modify the generation of this file.
const config = {};
config.sitecoreApiKey = process.env.VUE_APP_SITECORE_API_KEY || "D8080925-48D2-4B61-9513-F794D8D77025",
config.sitecoreApiHost = process.env.VUE_APP_SITECORE_API_HOST || "https://www.cisecurity.org",
config.jssAppName = process.env.VUE_APP_JSS_APP_NAME || "ngen",
config.defaultLanguage = process.env.VUE_APP_DEFAULT_LANGUAGE || "en",
config.graphQLEndpointPath = process.env.VUE_APP_GRAPH_QL_ENDPOINT_PATH || "/api/cisecurity",
config.graphQLEndpoint = process.env.VUE_APP_GRAPH_QL_ENDPOINT || `${config.sitecoreApiHost}${config.graphQLEndpointPath}`;
module.exports = config;